export default {
    pickUrl: "https://forms.gle/hqcQ6yg3UF54qd717",
    paypalUrl: "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=bowlpooldirector%40gmail%2ecom&lc=US&item_name=Bowl%20Pool%20Central&amount=5%2e50&currency_code=USD&button_subtype=services&bn=PP%2dBuyNowBF%3abtn_buynowCC_LG%2egif%3aNonHosted",
    venmoUser: "@Cameron-Powell-38",
    rulesUrl: "https://docs.google.com/document/d/e/2PACX-1vTIzeVmIwu7my0b7FQ65quyVVlge_-uTAsmNeroi_zP_oF_TShzZxugMHdOp7fZ-9VQEChHnkJHhrrD/pub?embedded=true",
    firstGameTime: "Dec. 14th at Noon Eastern",
    multiplayerUrlParam: "displayPlayers",
    // yearIfOld: " (2023 - 2024)",
    yearIfOld: "",
}